import React from 'react'
import styles from './cancel-signup.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const CancelSignup = ({ classes, onCancel }) => (
  <div className={classes.container}>
    <span
      className={classNames(classes.cancel, 'metrics__cancel-sign-up')}
      onClick={onCancel}>
      Cancel signup
    </span>
  </div>
)

export default injectSheet(styles)(CancelSignup)
